function languageReducer(language = null, action) {
  if (action.type === 'UPDATE_MODEL') {
    return action.data.language || language;
  }

  if (action.type === 'CHANGE_LANGUAGE') {
    return action.language || language;
  }

  if (action.type === 'SETTINGS_UPDATE' && !language) {
    const { localization } = action.data;
    if (localization && localization.language) {
      return localization.language;
    }
  }

  return language;
}

export default languageReducer;



// WEBPACK FOOTER //
// ./src/js/reducers/languageReducer.js